import setWithExpiry from './lib/set-with-expiry.js';
import getWithExpiry from './lib/get-with-expiry.js';
import addParameter from './lib/add-parameter.js';
import addToArray from './lib/add-to-array.js';
import getObject from './lib/get-object.js';
import keys from './lib/keys.js';
import encodeObject from './lib/encode-object.js';
import getTouchpoints from './lib/get-touchpoints.js';

let tracking = {
    addTrackingParameters: function(url, trackingParameters = {}) {

        const first = getWithExpiry(keys.first);
        const last = getWithExpiry(keys.last);
        const sg = getWithExpiry(keys.sgTracking);
        const touchpoints = getTouchpoints();

        if(first) {
            url = addParameter(url, 'landing', first);
        }

        if(last) {
            url = addParameter(url, 'referer', last);
        }

        if(sg) {
            url = addParameter(url, sg.origin, sg.origin_id);
        }

        Object.keys(trackingParameters).forEach(key => {
            if (['placement', 'position'].includes(key)) {
                url = addParameter(url, key, trackingParameters[key]);
            }
        });

        if (touchpoints && touchpoints.length > 0) {
            const urlWithTouchpoints = addParameter(
                url, 'touchpoints', encodeObject(touchpoints)
            );
            
            // only add touchpoints if the total url 
            // length is less than 2000 characters
            // otherwise the url might be too long for some browsers
            url = urlWithTouchpoints.length > 2000 ? 
                url : urlWithTouchpoints;
        }

        return url;
    },

    getTrackingObject: function() {

        const first = getWithExpiry(keys.first);
        const last = getWithExpiry(keys.last);
        const sg = getWithExpiry(keys.sgTracking);
        const touchpoints = getTouchpoints();

        let tracking = {};

        if (first) {
            tracking.landing = first;
        }

        if (last) {
            tracking.referer = last;
        }

        if (sg) {
            tracking[sg.origin] = sg.origin_id;
        }

        if (touchpoints && touchpoints.length > 0) {
            tracking.touchpoints = touchpoints;
        }

        return tracking;
    }
}

export default ({ app }, inject) => {

    app.context.$tracking = tracking;
    inject('tracking', tracking);

    // do the first / last page tracking
    app.router.afterEach((to, from) => {
        
        // TODO: Fix for Kortio, should probably be passed as option or similar
        if(!to.path.includes('out') && !to.path.match('\/kort\/[a-zA-Z0-9].*\/ansok\/')) {
            if(!getWithExpiry(keys.first)) {
                setWithExpiry(keys.first, to.path);
            }
            setWithExpiry(keys.last, to.path);
        }
    });

    var searchParams = new URLSearchParams(window.location.search);

    if(searchParams.has('gclid')) {
        const gclid = {
            origin: 'gclid', origin_id: searchParams.get('gclid')
        };

        setWithExpiry(keys.sgTracking, gclid);
        addToArray(keys.sgTouchPoints, gclid);
    }
    else if(searchParams.has('sgid')) {
        const sgid = {
            origin: 'sgid', origin_id: searchParams.get('sgid')
        };
        setWithExpiry(keys.sgTracking, sgid);
        addToArray(keys.sgTouchPoints, sgid);
    }
    else if(searchParams.has('msclkid')) {
        const msclkid = {  
            origin: 'msclkid', origin_id: searchParams.get('msclkid')
        };
        setWithExpiry(keys.sgTracking, msclkid);
        addToArray(keys.sgTouchPoints, msclkid);
    }
}